module.exports = __webpack_public_path__ + "static/media/local_service_stations.a82e2394.png";